const designSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>This is a card for a question inside the survey. By hovering over the card, you can see the areas where you can perform edit or delete actions. You can change whether the question is required or not, and you also have the option to change the question type.</h2>,
      placement: "bottom",
      target: "#designQuestionCard",
      title: "First step",
      scrollTo: false,
    },
    {
      content: <h2>You can add a new question to your survey by clicking this area.</h2>,
      placement: "bottom",
      target: "#designAddQuestion",
      title: "Second step",
      scrollTo: false,
    },
    {
      content: <h2>In the Input Panel tab located in the left menu, you will find the types of questions you can add to your survey. By clicking on them, you can add questions of that type to your survey.</h2>,
      placement: "bottom",
      target: "#designLeftMenuInputPanel",
      title: "Third step",
      scrollTo: false,
    },
    {
      content: <h2>In the QBank tab in the left menu, you can view the questions from the surveys you have access to. You can add the desired questions to your survey.</h2>,
      placement: "left",
      target: "#designLeftMenuQbank",
      title: "Fourth step",
      scrollTo: false,
    },
    {
      content: <h2>By clicking here, you can access the menu to change the survey's options.</h2>,
      placement: "left",
      target: "#designRigthMenuOptions",
      title: "Fifth step",
      scrollTo: false,
    },
    {
      content: <h2>In this section, you can view the pages and sections of the survey, add new ones, or delete existing ones. You can also change the order of pages and sections by drag-and-drop.</h2>,
      placement: "left",
      target: "#designRigthMenuSections",
      title: "Sixth step",
      scrollTo: false,
    },
    {
      content: <h2>By clicking here, you can preview your survey and observe the changes you have made.</h2>,
      placement: "left",
      target: "#designSurveyPreview",
      title: "Seventh step",
      scrollTo: false,
    }
  ]
  export default designSteps;